import { apiFetch } from './http';

// ── Types ──
// ACP (Agentic Control Panels) are per-customer panels deployed into the
// shared `peregrine-acp-panels-*` bucket and served at `{slug}.panels.gdna.io`.
// Backed by the ops API `/ops/acp-panels` routes (acp-panel handler).

export type AcpPanelStatus = 'active' | 'provisioning' | 'inactive';

export interface AcpPanel {
  slug: string;
  productId: string;
  customerId: string;
  domain: string;
  baseDomain?: string;
  description: string;
  status: AcpPanelStatus;
  currentVersion: string;
  lastDeployAt: string;
  deployCount: number;
  s3Bucket: string;
  cfDistributionId: string;
  cfDomainName?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AcpDeployRecord {
  version: string;
  files: number;
  source: string;
  deployedBy: string;
  deployedAt: string;
}

export interface AcpPanelDetail extends AcpPanel {
  deployHistory: AcpDeployRecord[];
}

export interface AcpHealthCheckResult {
  slug: string;
  domain: string;
  code: number;
  latencyMs: number;
  error?: string;
  checkedAt: string;
}

// ── API Client ──


export async function fetchAcpPanels(): Promise<{ panels: AcpPanel[] }> {
  return apiFetch('/ops/acp-panels');
}

export async function fetchAcpPanel(slug: string): Promise<AcpPanelDetail> {
  return apiFetch(`/ops/acp-panels/${slug}`);
}

export async function registerAcpPanel(input: {
  slug: string;
  productId?: string;
  customerId?: string;
  domain?: string;
  description?: string;
  s3Bucket?: string;
  cfDistributionId?: string;
  currentVersion?: string;
}): Promise<AcpPanel> {
  return apiFetch('/ops/acp-panels', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function deployAcpPanel(
  slug: string,
  input: { source?: string; files?: Record<string, string>; version?: string; deployedBy?: string },
): Promise<{ status: string; slug: string; version: string; files: number; invalidated: boolean }> {
  return apiFetch(`/ops/acp-panels/${slug}/deploy`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function healthCheckAcpPanel(slug: string): Promise<AcpHealthCheckResult> {
  return apiFetch(`/ops/acp-panels/${slug}/health`, { method: 'POST' });
}
